<template>
  <div class="booking_wraps">
   <div class="container container-alert">
     <div class="alert_calender">
        <vs-alert color="#fff">
          <template #title> Dette er din private side hos oss. </template>
          Her kan du se biler som du har registrert hos oss, du kan legge til,
          endre og slette dine timer selv. Du kan også se historikk på hva som
          er gjort og når det er utført på din bil.
        </vs-alert>
      </div>
   </div>
    <carslistApp v-if="car_list" @clicked="config_from_car_list_comp"></carslistApp>
    <calenderApp v-if="calender" @clicked="config_from_calender_comp" :car_info_prop="car_info" :total_pass_prop="total_pass" :car_reservation="car_reservation"></calenderApp>
   <!--  -->
    <carserviceApp v-if="service_cart" @clicked="config_from_service_cart_comp" :car_number_pass="car_number"></carserviceApp>
    <carsuggestionApp v-if="suggistion_cart" @clicked="config_from_suggistion_cart_comp" :car_number_pass="car_number"></carsuggestionApp>
  </div>
</template>

<script>
import calenderApp from '@/components/booking/calenderApp.vue';
import carslistApp from '@/components/booking/carslistApp.vue';
import carserviceApp from '@/components/booking/carserviceApp.vue';
import carsuggestionApp from '@/components/booking/carsuggestionApp.vue';
export default {
  components: { calenderApp, carslistApp , carserviceApp , carsuggestionApp},
  name: "Booking",
  data(){
    return{
        car_list:true,
        service_cart:false,
        suggistion_cart:false,
        calender:false,
        car_reservation:{},
        car_number:'',
        car_info:{},
        total_pass:0
    }
  },
  methods:{
    config_from_car_list_comp(fisrt_config){
      this.car_list = fisrt_config.carlist;
      this.service_cart = fisrt_config.service_cart;
      this.suggistion_cart = fisrt_config.suggestion_cart;
      this.calender = fisrt_config.calender;
      // car number setter
      this.car_number = fisrt_config.car_number;
      // car info ##
      this.car_info = fisrt_config.car_info;
      this.car_reservation = fisrt_config.car_reservation;
      console.log(this.car_info, 'car_info setter');
      console.log(fisrt_config , 'first config in parent');
    },
    config_from_service_cart_comp(second_config){
      console.log(second_config);
      this.car_list = second_config.carlist;
      this.service_cart = second_config.service_cart;
      this.suggistion_cart = second_config.suggestion_cart;
      this.calender = second_config.calender;
      console.log('parent service cart');
    },
    config_from_suggistion_cart_comp(third_config){
      this.car_list = third_config.carlist;
      this.service_cart = third_config.service_cart;
      this.suggistion_cart = third_config.suggestion_cart;
      this.calender = third_config.calender;
        // setter total from main service
      this.total_pass = third_config.total_pass;

    },
   config_from_calender_comp (forth_config) {
    this.car_list = forth_config.carlist;
      this.service_cart = forth_config.service_cart;
      this.suggistion_cart = forth_config.suggestion_cart;
      this.calender = forth_config.calender;
      }
  },
    mounted(){
         document.body.classList.add('BookingPage');
    },
    destroyed(){
      document.body.classList.remove('BookingPage');
    }
};
</script>
<style lang="scss" scoped>
.booking_wraps{
    padding-top: 10px;
}
</style>